import React, { useState, useEffect } from "react";
import SmBannerImage from "../../images/po-main-banner-image.png";
import ImageThumbLeft1 from "../../images/banner-left-img-1.png";
import ImageThumbRight1 from "../../images/banner-right-img-1.png";
import ImageThumbRight2 from "../../images/banner-right-img-2.png";
import ImageThumbRight3 from "../../images/banner-right-img-3.png";
import ImageThumbRight4 from "../../images/banner-right-img-4.png";
import { Link } from "gatsby";
import InView from "react-intersection-observer";
import HeaderAnim from '../common/utils/animations/textRevealAnimation';
import LazyLoad from 'react-lazyload';
//import AOS from 'aos';
import 'aos/dist/aos.css'

export default function MainBanner() {
  let AOS;

  useEffect(() => {
    const AOS = require("aos");
    AOS.init({
      once: true,
    });
  }, []);

  useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });
  const [isVisible, setIsVisible] = useState(false);
  return (
    
    <div className="cs-page-main-banner-section section-gap-large po-cs-main-banner">
      <InView onChange={(inView) => setIsVisible(inView)} className={isVisible ? "is-inview" : ""}>
        <div className="cs-banner-image d-flex align-end justify-center">
          <div className="container d-flex flex-wrap align-start justify-center">
              <div className="cs-banner-image-inner">
                  <img data-aos="zoom-in" data-aos-offset="-300" data-aos-duration="700" src={SmBannerImage} title="Patient experience mobile app" alt="Patient experience app" width="470" height="819" />
                  <div className="banner-bg-images-left" data-aos="fade-in" data-aos-offset="-300" data-aos-delay="700" data-aos-duration="500"></div>
                  <div className="banner-bg-images-right" data-aos="fade-in" data-aos-offset="-300" data-aos-delay="1000" data-aos-duration="500"></div>
                  <div className="banner-bg-images-right1" data-aos="fade-in" data-aos-offset="-300" data-aos-delay="1200" data-aos-duration="500"></div>
                  <div className="banner-bg-images-right2" data-aos="fade-in" data-aos-offset="-300" data-aos-delay="1400" data-aos-duration="500"></div>
                  <div className="banner-bg-images-right3" data-aos="fade-in" data-aos-offset="-300" data-aos-delay="1600" data-aos-duration="500"></div>
              </div>
          </div>
        </div>
      </InView>
      <div className="cs-main-banner-detail">
        <InView onChange={(inView) => setIsVisible(inView)}>
          <div className="container">
            <div className="row d-flex flex-wrap row-banner-title">
              <div className="col left-bar">
                <h1>Making patient recovery fast and personalized</h1>
              </div>
              <div className="col right-bar">
                <h3>How we built personalized and automated patient experience platform for PhysioOutcomes?</h3>
              </div>
            </div>
            <div className="row d-flex flex-wrap">
              <div className="col left-bar">
                <p>Strategy · DevOps · Transformation · Engineering · Innovation</p>
              </div>
              <div className="col right-bar">
                {/*<Link className="button button-xsmall button-white-border" to="/contact/">Let's Chat</Link>*/}
              </div>
            </div>
          </div>
        </InView>
      </div>
    </div>
    
  );
}